import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as UploadPictureIcon } from "../../assets/icons/Upload_Picture.svg";
import CheckMark from "../../assets/icons/CheckMark.svg";
import { Link } from "react-router-dom";

const Settings = () => {
  const [changepass, setChangepass] = useState(false);
  const navigate = useNavigate();

  return (
    <section className="flex">
      <div className="m-10 w-full ">
        <h1 className="text-4xl font-semibold sm:text-left text-center mb-5">
          Account Settings
        </h1>
        <div className="space-y-10">
          <div className="bg-[#F1F1F1] p-5 md:p-10">
            <div className="flex flex-col items-center justify-between mb-6 md:flex-row">
              <h1 className="mb-4 text-2xl text-secondary font-semibold md:mb-0">
                Display Information
              </h1>
              <div className="flex items-center gap-x-2 text-primary">
                <Link
                  to="/dashboard/profile/edit"
                  className="flex items-center gap-x-2"
                >
                  {/* <img src="" alt="Edit_Icon" className="w-6 h-6" /> */}
                  <h4 className="text-sm md:text-base">Edit</h4>
                </Link>
              </div>
            </div>

            <div className="flex flex-col items-center gap-4 md:flex-row md:gap-x-20">
              <div className="flex flex-col items-center space-y-3">
                {/* {imagePreview ? (
                <div className="flex flex-col items-center">
                    <img src={imagePreview} alt="Profile Preview" className="w-32 h-32 rounded-lg md:w-52 md:h-52" />
                    <div className="flex justify-center mt-2 space-x-2 w-52">

                    </div>
                </div>
            ) : ( */}
                <label
                  htmlFor="fileInput"
                  className="w-32 h-32 md:w-52 md:h-52 rounded-lg bg-[#D2D5D7] flex items-center justify-center cursor-pointer"
                >
                  {/* Assuming UploadPictureIcon is a component that accepts these props */}
                  <UploadPictureIcon
                    className="w-10 h-10 opacity-50 group-hover:opacity-100"
                    width={60}
                    onClick={() => navigate("/dashboard/profile/edit")}
                  />
                </label>
                {/* )} */}
              </div>

              <div className="flex flex-col space-y-4 md:flex-row md:items-center md:gap-x-20 md:space-y-0">
                <div className="flex flex-col items-start space-y-8">
                  <div>
                    <h3 className="text-lg text-gray-600 font-semibold">
                      Name :
                    </h3>
                    <p className="text-lg font-semibold text-secondary md:text-2xl">
                      {/* {profile?.fullName} */}
                    </p>
                  </div>
                  <div>
                    <h3 className="text-lg text-gray-600  font-semibold">
                      Age :
                    </h3>
                    <p className="text-lg font-semibold text-secondary md:text-2xl">
                      {/* {calculate_age(profile?.dob)} */}
                    </p>
                  </div>
                  <div>
                    <h3 className="text-lg text-gray-600  font-semibold">
                      Gender :
                    </h3>
                    <h3 className="text-lg font-semibold text-secondary md:text-2xl">
                      {/* {profile?.gender} */}
                    </h3>
                  </div>
                  <div>
                    <h3 className="text-lg text-gray-600  font-semibold">
                      Address :
                    </h3>
                    <p className="text-lg font-semibold text-secondary md:text-2xl">
                      {/* {profile?.address} */}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-[#F1F1F1] p-5 md:p-10">
            <div className="flex flex-col items-center justify-between mb-6 md:flex-row">
              <h1 className="text-2xl text-secondary font-semibold">
                Login Information
              </h1>
            </div>
            <div className="flex flex-col items-center gap-4 md:flex-row md:gap-x-20">
              <div className="flex flex-col sm:gap-y-10 gap-y-5">
                <div className="flex flex-col sm:flex-row sm:items-center sm:gap-x-48 gap-y-5">
                  <div>
                    <h3 className="text-gray-600 ">Your Email ID:</h3>
                    <div className="flex items-center text-lg text-secondary font-semibold md:text-2xl gap-x-2">
                      {/* {profile?.userId?.email} */}
                      <img src={CheckMark} alt="Check Mark" width={25} />
                    </div>
                  </div>
                </div>
                <div>
                  <h3 className="text-gray-600">Password: </h3>
                  <h3 className="text-2xl font-semibold">
                    **************{" "}
                    <Link
                      // to="/dashboard/reset_password"
                      onClick={() => setChangepass(!changepass)}
                      className="text-sm text-blue-600 transition duration-300 ease-in-out hover:text-blue-800"
                    >
                      (Change Password)
                    </Link>
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>

        {changepass && (
          <form
            className="my-10 space-y-4" //onSubmit={handleChange}
          >
            <div className="flex flex-col w-full text-xl">
              <label className="text-lg mb-1">Current Password</label>
              <input
                type="password"
                name="currentPassword"
                required
                // value={currentPassword || ""}
                // onChange={(e) => setCurrentPassword(e.target.value)} // You might need a new handler to update the recipients state
                className="w-full bg-slate-100 py-2 rounded-md px-3"
              />
            </div>
            <div className="flex flex-col w-full text-2xl">
              <label className="text-lg mb-1">New Password</label>

              <input
                type="password"
                name="newPassword"
                required
                // value={newPassword || ""}
                // onChange={(e) => setNewPassword(e.target.value)} // You might need a new handler to update the recipients state
                className="w-full bg-slate-100 py-2 rounded-md px-3"
              />
            </div>
            <div className="flex flex-col w-full text-2xl">
              <label className="text-lg mb-1">Confirm New Password</label>
              <input
                type="password"
                name="confirmNewPassword"
                required
                // value={confirmNewPassword || ""}
                // onChange={(e) => setConfirmNewPassword(e.target.value)} // You might need a new handler to update the recipients state
                className="w-full bg-slate-100 py-2 rounded-md px-3"
              />
            </div>
            {/* {loader ? (
            // <Spinner props={" "} size={"80"} />
            <div></div>
          ) : ( */}
            <button className="bg-primary rounded-md py-3 text-white sm:text-xl w-full hover:opacity-90">
              Change Password
            </button>
            {/* )} */}
          </form>
        )}
      </div>
    </section>
  );
};

export default Settings;
